import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './Accordion.module.scss';
import { AccordionPanel } from './AccordionPanel';
import { AccordionSection } from './AccordionSection';
import { AccordionTitle } from './AccordionTitle';
import { useAccordion } from './useAccordion';
import { AccordionContext } from './useAccordionContext';
import clsx from 'clsx';
import React, { useMemo } from 'react';

export const Accordion = (props) => {
  const {
    canOpenMultiple = false,
    marginBottomMobile,
    placement,
    children,
    customClasses = null,
    sectionIds = () => null,
    className = {},
  } = props;
  const styles = mergeClasses(defaultClasses, customClasses);

  // The talon is the source of truth for the context value.
  const talonProps = useAccordion({
    canOpenMultiple,
    children,
    sectionIds,
  });
  const { handleSectionToggle, openSectionIds } = talonProps;

  const contextValue = useMemo(
    () => ({
      handleSectionToggle,
      openSectionIds,
    }),
    [handleSectionToggle, openSectionIds],
  );

  return (
    <AccordionContext.Provider value={contextValue}>
      <div
        className={clsx(styles.accordionWrapper, className, {
          [` ${styles.marginBottomMobile}`]: marginBottomMobile,
          [styles.accordionWrapperOnCmsPages]:
            placement === 'cmsPages' && placement,
          [styles.accordionWrapperPrimary]:
            placement === 'primary' && placement,
        })}
        style={{
          '--mobile-accordion-marginBottom':
            marginBottomMobile && `${marginBottomMobile}px`,
        }}
      >
        {children}
      </div>
    </AccordionContext.Provider>
  );
};

Accordion.Section = AccordionSection;
Accordion.Title = AccordionTitle;
Accordion.Panel = AccordionPanel;

export default Accordion;
